import { Loader } from "./styles";
import Image from "../Image";
import logo from "../../assets/logo.svg";
import spinner from "../../assets/spinnerloader.svg";

interface ComponentProps {
  size?: number
}

const Component = ({ size = 150 }: ComponentProps) => {
  return (
    <Loader >
      <Image src={spinner} alt="Logo" width={size} height={size} />
    </Loader>
  );
};

export default Component;
